import { IFlowEventData } from 'types/analytics';

export const TEXT_KEYS = {
    MESSAGE: 'success-page__message',
    CONGRAT_MESSAGE: 'success-page__congrats-message'
};

export const GAME_PACKSHOT_CSS_VARIABLE: string = '--game-packshot-image';

export const SUCCESS_FLOW_STEP: Pick<IFlowEventData, 'flowStep'> = {
    flowStep: 'acquisition successful'
};

export enum SUCCESS_FLOW_ACTIONS {
    DISPLAY = 'registration successful : registered'
}
